import React, { Component } from 'react'
import dayjs from 'dayjs'
import SetStatusButton from './SetStatusButton'

export default class DeliveryRow extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    render() {
        const { delivery } = this.props

        const rowColor = (qsign) => {
            if (qsign == false) return "#ff9797"

            return "#ffffff"
        }

        const isDelivered = delivery.checkout && delivery.checkout.date

        return (
            <tr style={{ backgroundColor: rowColor(delivery.qsign) }}>
                <td>{delivery.vendor && delivery.vendor.name ? delivery.vendor.name : '-'}</td>
                <td>{delivery.lock.custom_name}<br/>{delivery.lock.address.street}<br/>{delivery.lock.address.zip} {delivery.lock.address.city}</td>
                <td>{delivery.packageid}</td>
                <td>{delivery.deliveryId || delivery.carrierInternalOrderId}</td>
                <td>{dayjs(new Date(parseInt(delivery._id.substring(0, 8), 16) * 1000)).format('HH:mm DD/MM')}</td>
                <td>{isDelivered ? dayjs(delivery.checkout.date).format('HH:mm DD/MM') : '-'}</td>
                <td>{delivery.qsign == false ? 'Nej' : isDelivered ? 'Ja' : '-'}</td>
                <td>
                    {delivery.driverName}
                    <br />
                    {delivery.driverAliases || ''}
                </td>
                <td><SetStatusButton delivery={delivery} /></td>
            </tr>
        )
    }
}

